module.exports = ".description {\n  font-size: 14px; }\n"